import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Checkbox } from '@factorialco/f0-react'

interface WorkAreasFirstCellProps {
  title: string
  isChecked: boolean
  onClick: () => void
  isCheckboxEnabled: boolean
}

const WorkAreasFirstCell = ({
  title,
  isChecked,
  onClick,
  isCheckboxEnabled,
}: WorkAreasFirstCellProps) => {
  return (
    <Box flexDirection="row" width="full" alignItems="center">
      <Box
        flexDirection="row"
        data-testid="menu-order"
        alignItems="center"
        style={{
          transform: 'scale(0.8)',
          opacity: isCheckboxEnabled ? '1' : '0',
          transition: (() => {
            return 'opacity .1s ease-in-out'
          })(),
        }}
      >
        <F0Checkbox checked={isChecked} onCheckedChange={() => onClick()} />
      </Box>
      <Box flexDirection="row" width="full">
        <Text size="200" weight="medium" className="text-f1-foreground-secondary">
          {title}
        </Text>
      </Box>
    </Box>
  )
}

export { WorkAreasFirstCell }
